<template>
  <heat-device :color="getColor" class="w-100" />
</template>

<script>
import BaseIcon from '@/components/icons/mixins/BaseIcon';

export default {
  name: 'HeatDeviceWrapper',
  mixins: [
    BaseIcon,
  ],
  data() {
    return {
      turnedOffColor: '#CCCCCC',
      heatingOnColor: '#EB7087',
    };
  },
  computed: {
    getColor() {
      if (this.isHeatingOn) {
        return this.heatingOnColor;
      }
      return this.turnedOffColor;
    },
    isHeatingOn() {
      return this.getVarsValue('HVAC_HEAT') || false;
    },
  },
};
</script>

<style scoped>

</style>
